import { PrimaryTokenTableEntry } from '../dsAuth/data/AuthTypes';
import { OIDCTokensUpdateReason } from '../oidc/OIDCTokenManager';
import { PrimaryTokensUpdateReason } from '../TokenManager';
import { OIDCTokensTableEntry } from '../oidc/TypeDefinitions';
import { Event } from './Event';
export enum EventType {
	UPDATED_OIDC_TOKENS = 'aml/tokens/oidc/updated',
	UPDATED_PRIMARY_TOKENS = 'aml/tokens/primary/updated',
	ANALYTICS_TRACKING_EVENT = 'aml/analytics/trackevent',
}

interface OIDCTokenObj extends OIDCTokensTableEntry {
	revocationEndpoint?: string;
}

interface AnalyticsProperty {
	propertyName: string;
	propertyValue: string;
}

interface AnalyticsEventPayload {
	category: string;
	action: string;
	label: string;
	value: number;
	properties: AnalyticsProperty[];
}

export interface OIDCTokensUpdatedEvent extends Event<{ tokens: OIDCTokenObj[] }> {
	type: EventType.UPDATED_OIDC_TOKENS;
	meta: {
		reason: OIDCTokensUpdateReason;
	};
}

export interface PrimaryTokensUpdatedEvent
	extends Event<{ tokens: PrimaryTokenTableEntry[] }> {
	type: EventType.UPDATED_PRIMARY_TOKENS;
	meta: {
		reason: PrimaryTokensUpdateReason;
	};
}

export interface AnalyticsEvent extends Event<AnalyticsEventPayload> {
	type: EventType.ANALYTICS_TRACKING_EVENT;
}
